<template>
    <div>
        <v-data-table 
            :headers="headers"
            :items="usuarios"
            :search="search"
			items-per-page="5"
            sort-by="noFactura"
            sort-desc="noFactura"
            class="elevation-1 oculto-impresion"

            >
            
            <template class="oculto-impresion" v-slot:top>
                <v-row class="pa-2">
                    <v-col cols="12" sm="3">
                        <v-card-actions class="rounded-xl light-blue lighten-5 mx-5">
                                <vue-excel-xlsx v-if="esAdministrador || esSupervisor"
                                    :data="usuarios"
                                    :columns="columns"
                                    :filename="'Reporte de Ventas para Sistema Xero de: '+$store.state.usuario.localidad"
                                    :sheetname="'Ventas'"
                                    >
                                    <v-btn fab="" color="success">  <v-icon large="">mdi-file-excel </v-icon> </v-btn>
                                </vue-excel-xlsx> 
                            <v-card-title>Ventas</v-card-title>
                        </v-card-actions>
                    </v-col>
                    <v-col cols="12" sm="4">    
                        <v-text-field v-model="search"  append-icon="mdi-magnify"
                         label="Buscar" single-line hide-details
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-text-field  v-model="start" type="date" label="Fecha inicial"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-text-field  v-model="end"  type="date" label="Fecha final"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="1">
                        <v-btn :loading="loading" color="info" @click="listarFechas()" fab > <v-icon fab> mdi-cloud-search </v-icon> </v-btn>
                    </v-col>
                </v-row>
               
            </template>

            <template v-slot:no-data>
                <v-data-table item-key="name" class="elevation-1" loading loading-text="Cargando datos... Por favor espere"></v-data-table>
                <v-btn color="primary" @click="initialize">Reiniciar</v-btn>
            </template>
        </v-data-table>
        <template class="pa-3">
            <v-snackbar
                    v-model="snackbar" top vertical="" :timeout="5000"
                    >
                    {{ Mensaje }}
                    <v-btn
                    color="info"
                    text
                    @click="snackbar = false"
                    >
                    Cerrar
                    </v-btn>
            </v-snackbar>
            
        </template>
    </div>
</template>

<script scoped>
import axios from 'axios'
import jsPDF from 'jspdf'
import VueExcelXlsx from "vue-excel-xlsx";
import Vue from "vue";
import html2canvas from 'html2canvas';

Vue.use(VueExcelXlsx);
  export default {
    data: () => ({
    today: new Date().toISOString().substr(0, 10),
    focus: new Date().toISOString().substr(0, 10),
    headers: [
		{ text: "ContactName", value: "nombreReceptor" }, 
		{ text: 'EmailAddress', value: 'correoReceptor' },   
		{ text: 'POAddressLine1', value: 'na' },  
		{ text: 'POAddressLine2', value: 'na' },  
		{ text: 'POAddressLine3', value: 'na' },  
		{ text: 'POAddressLine4', value: 'na' },  
		{ text: 'POCity', value: 'na' },  
		{ text: 'PORegion', value: 'na' },  
		{ text: 'POPostalCode', value: 'na' },  
		{ text: 'PoCountry', value: 'na' },  
		{ text: "InvoiceNumber", value: "noFactura" },
		{ text: "Reference", value: "metodoPago" },
		{ text: "Date", value: "fecha" },
		{ text: "DueDate", value: "fecha" },
		{ text: 'Total', value: 'total' },  
		{ text: 'InventoryItemCode', value: 'na' },  
		{ text: 'Description', value: 'na' },  
		{ text: 'Quantity', value: 'cantidad' },  
		{ text: "UnitAmount", value: "unitAmount" },
		{ text: "Discount", value: "descuento" },
		{ text: "AccountCode", value: "accountCode" },
		{ text: "TaxType", value: "taxType" },
		{ text: 'TaxAmount', value: 'impuesto13' }, 
		{ text: 'TrackingName1', value: 'localidad' }, 
		{ text: 'TrackingOption', value: 'na' }, 
		{ text: 'TrackingName2', value: 'na' }, 
		{ text: 'TrackingOption2', value: 'na' }, 
		{ text: 'Currency', value: 'moneda' }, 
		{ text: 'BrandingTheme', value: 'na' }, 
		{ text: 'Monto Pagado', value: 'total' },  
		{ text: 'Cuenta contable', value: 'cuentaContable' },
		{ text: 'FechaPago', value: 'fecha' }, 
		{ text: 'Referencia de Pago', value: 'referencia' },  
    ],
	columns: [
		{ label: "ContactName",field: "nombreReceptor", }, 
		{ label: 'EmailAddress', field: 'correoReceptor',  },   
		{ label: 'POAddressLine1', field: 'na',  },  
		{ label: 'POAddressLine2', field: 'na',  },  
		{ label: 'POAddressLine3', field: 'na',  },  
		{ label: 'POAddressLine4', field: 'na',  },  
		{ label: 'POCity', field: 'na',  },  
		{ label: 'PORegion', field: 'na',  },  
		{ label: 'POPostalCode', field: 'na',  },  
		{ label: 'PoCountry', field: 'na',  },  
		{ label: "InvoiceNumber",field: "noFactura", },
		{ label: "Reference",field: "metodoPago", },
		{ label: "Date",field: "fecha", },
		{ label: "DueDate",field: "fecha", },
		{ label: 'Total', field: 'total' },  
		{ label: 'InventoryItemCode', field: 'na' },  
		{ label: 'Description', field: 'na' },  
		{ label: 'Quantity', field: 'cantidad' },  
		{ label: "UnitAmount",field: "unitAmount", },
		{ label: "Discount",field: "descuento", },
		{ label: "AccountCode",field: "accountCode", },
		{ label: "TaxType",field: "taxType", },
		{ label: 'TaxAmount', field: 'impuesto13',  }, 
		{ label: 'TrackingName1', field: 'localidad',  }, 
		{ label: 'TrackingOption', field: 'na',  }, 
		{ label: 'TrackingName2', field: 'na',  }, 
		{ label: 'TrackingOption2', field: 'na',  }, 
		{ label: 'Currency', field: 'moneda',  }, 
		{ label: 'BrandingTheme', field: 'na',  }, 
		{ label: 'Monto Pagado', field: 'total' },  
		{ label: 'Cuenta contable', field: 'cuentaContable',  },
		{ label: 'FechaPago', field: 'fecha',  }, 
		{ label: 'Referencia de Pago', field: 'referencia',  },  
	],
    start : new Date().toISOString().substr(0, 10),
    end : new Date().toISOString().substr(0, 10),
    usuarios: [],
    
    }),

    computed: {
	esAdministrador(){
        return this.$store.state.usuario && this.$store.state.usuario.rol =='Administrador';
	},
	esSupervisor(){
		return this.$store.state.usuario && this.$store.state.usuario.rol =='Supervisor';
	},
	esVendedor(){
		return this.$store.state.usuario && this.$store.state.usuario.rol =='Vendedor';
	},
	esCliente(){
		return this.$store.state.usuario && this.$store.state.usuario.rol =='Cliente';
	},
    },
    

    watch: {
      dialog (val) {
        val || this.close()
      },
      
    },

    created () {
      this.listarFechas();
    },

    methods: {
        crearPDF(){
           var columns = [
            {title: "Factura", dataKey: "noFacturaReal"},
            {title: "Estado", dataKey: "estado"}, 
            {title: "Fecha", dataKey: "fecha"}, 
            {title: "Excento", dataKey: "excento"},
            {title: "IVA", dataKey: "iva"},
            {title: "Total", dataKey: "ventaTotal"},
            {title: "Cliente", dataKey: "cliente"},
            ];
            var rows = [];

            this.usuarios.map(function(x){
                rows.push({noFacturaReal:x.noFacturaReal,excento:x.exento,estado:x.mensajeRespuesta,fecha:x.fecha,iva:x.impuesto,ventaTotal:x.ventaTotal,cliente:x.nombreReceptor});
            });

            // Only pt supported (not mm or in)
            var doc = new jsPDF('p', 'pt');
            doc.autoTable(columns, rows, {
                margin: {top: 60},
                addPageContent: function(data) {
                    doc.text("Listado de Ventas", 40, 30);
                }
            });
            doc.save('ReporteVentas.pdf');
        },
        crearPDFFactura(){
            var fact = this.noFactura;
             var quotes = document.getElementById('factura');
                html2canvas(quotes).then(function (canvas) {
                    var imgData = canvas.toDataURL('https://i.ibb.co/7rj9fLf/the-one-blanco.jpg');
                    var imgWidth = 210;
                    var pageHeight = 285;
                    var imgHeight = canvas.height * imgWidth / canvas.width;
                    var heightLeft = imgHeight;
                    var doc = new jsPDF();
                    var position = 0;

                    doc.addImage(imgData, 'JPG', 0, position, imgWidth, imgHeight);                    
                    doc.save('ComprobanteVenta'+fact+'.pdf');
                });
        },
        listarFechas(){
            if(this.start == '' || this.end == ''){
                this.snackbar = true;
                this.Mensaje = 'Debe seleccionar una fecha inicial y final'
                return;
		   }
		   	this.loading = true;
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion= {headers : header};
            axios.get('api/RepVentasVistas/ConsultaFechasXero/'+this.start+'/'+this.end+'/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
                //console.log(response);
				me.usuarios=response.data;
				me.loading = false;
            }).catch(function(error){
                console.log(error);
				me.loading = false;
            });
        },

		close () {
			this.dialog = false;
			this.limpiar();
		},
    },
  	mounted(){
      this.getProductosMasVendidos();
  	}
  }

</script>
<style scoped>
    @media print {
    .oculto-impresion,
    .oculto-impresion * {
        display: none !important;
    }
    } 
</style>
My CRUD